export const Reorder = <T,>(list: T[], startIndex: number, endIndex: number): T[] => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

export const ReorderActions = <T,>(list: T[], startIndex: number, endIndex: number): T[] => {
    return Reorder(list, startIndex, endIndex).map((r, index) => ({ ...r, DisplayOrder: index }));
}
